module.exports = __webpack_public_path__ + "static/media/ampleforth.c4cfac0e.svg";